import { gql } from '@apollo/client';

export const ALL_INSTITUTION_SSP_USERS_FOR_SELECT_INPUT = gql`
  query AllInstitutionSPPUsers($input: allSPPUserInput!) {
    users: allInstitutionsSSPUsers(input: $input) {
      id
      firstName
      lastName
    }
  }
`;
